<template>
  <div class="modal fade show custom-modal" id="EndorsementTypeModal" role="dialog" :class="{'modal-show':showModal}">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header ml-3 pl-2">
          <h5 class="modal-title ml-4 float-left font-weight-bold">
            Endorsement Types 
          </h5>
          <button type="button" class="close" data-dismiss="modal" @click="closeEndorsementTypeModal()" id="endorsement-type-cross-close">
            &times;
          </button>
        </div>
        <div class="mr-4">
          <div class="style-border ml-5 mt-1" />
        </div>
        <div class="modal-body mt-4 pl-5 pb-5">
           <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div v-for="type in state.types" :key="type.code">
               {{ type.name }}
              </div>
            </div>
             <div class="col-lg-6 col-md-6 col-sm-12">
              <div v-for="endorsements in state.typesOfEndorsement" :key="endorsements.code">
               {{ endorsements.name }}
              </div>
            </div>
            </div>
            <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import { reactive , watch} from "@vue/composition-api";
export default {
  name: "EndorsementTypeModal",
  props:['endorsementTypesApplicable','showModal'],
  components: {
    carousel
  },
  setup(props, { root, parent }) {
    let state = reactive({
      types: [],
      typesOfEndorsement:[]
    });
    function closeEndorsementTypeModal(){
      parent.closeEndorsementTypeModal();
    }
    watch(()=>props.showModal, ()=>{
      state.types = [];
      state.typesOfEndorsement = [];
      let endorseLength = Math.ceil(props.endorsementTypesApplicable.length/2);
      for(let i=0; i<endorseLength; i++){
        state.types.push(props.endorsementTypesApplicable[i]);
      }
      for(let j=endorseLength; j<props.endorsementTypesApplicable.length; j++){
        state.typesOfEndorsement.push(props.endorsementTypesApplicable[j]);
      }
    });
    return {
      state,
      closeEndorsementTypeModal
    };
  },
};
// export default {
//   name: "EndorsementTypeModal",
//   components: { carousel },
//   props: ['endorsementTypesApplicable','showModal'],
//   data: function () {
//     return {
//       types: [],
//       typesOfEndorsement:[]
//     };
//   },
//   watch : {
//     endorsementTypesApplicable : function(){
//       this.types = [];
//       this.typesOfEndorsement = [];
//       let endorseLength = Math.ceil(this.endorsementTypesApplicable.length/2);
//       for(let i=0; i<endorseLength; i++){
//         this.types.push(this.endorsementTypesApplicable[i]);
//       }
//       for(let j=endorseLength; j<this.endorsementTypesApplicable.length; j++){
//         this.typesOfEndorsement.push(this.endorsementTypesApplicable[j]);
//       }
//     }
//   }
// };
</script>

<style scoped>
button.close {
  padding-top: 13px;
  text-align: right;
}
.checkbox-position {
  left: 15px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;

}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
</style>